import React from 'react';
import { array, bool, func, shape, string } from 'prop-types';

import { FileInput, Label } from '@atlas/ui';

import Field from 'common/Form/Field';

const FileField = ({ field, onChange = () => {} }) => {
  const {
    disabled,
    // placeholder,
    errors,
    label,
    name,
    touched,
  } = field;

  const fieldErrors = touched && errors ? errors : [];

  return (
    <Field options={field}>
      {label && <Label message={label} />}

      <FileInput disabled={disabled} errors={fieldErrors} name={name} onChange={onChange} />
    </Field>
  );
};

FileField.propTypes = {
  field: shape({
    disabled: bool,
    errors: array,
    label: string,
    name: string.isRequired,
    placeholder: string,
    touched: bool,
    warnings: array,
  }).isRequired,
  onChange: func,
};

export default FileField;
